import {
  PhoneNumberInput,
  usePhoneInput,
} from "mt-components/PhoneNumberInput";
import { Dispatch, SetStateAction } from "react";
import { MdEmail, MdPhoneEnabled } from "react-icons/md";
import SearchCard, {
  SearchCardProps,
} from "../../MultiCardModal/components/SearchCard";
import TimeZonePicker, { TimeZonePickerProps } from "./TimeZonePicker";

type ContactCardProps = Omit<SearchCardProps, "label"> & {
  phoneInput: ReturnType<typeof usePhoneInput>;
  email: string;
  setEmail: Dispatch<SetStateAction<string>>;
  disabled?: boolean;
} & Pick<TimeZonePickerProps, "timeZone" | "setTimeZone">;

export default function ContactCard({
  email,
  setEmail,
  phoneInput,
  timeZone,
  setTimeZone,
  ...searchCardProps
}: ContactCardProps) {
  return (
    <SearchCard
      {...searchCardProps}
      label={
        <div style={{ display: "flex", flexDirection: "row", gap: "0.5rem" }}>
          {[
            <MdEmail
              key="email-icon"
              style={{ opacity: `${email ? 100 : 30}%` }}
              size={20}
            />,
            <MdPhoneEnabled
              key="phone-icon"
              style={{ opacity: `${phoneInput.localNumber ? 100 : 30}%` }}
              size={20}
            />,
          ].filter(Boolean)}
        </div>
      }
    >
      email
      <input
        type="email"
        style={{
          width: "100%",
          padding: "0.5rem",
          borderRadius: 8,
          marginBottom: 12,
        }}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      mobile number (WhatsApp/Line)
      <PhoneNumberInput
        {...phoneInput}
        flagPosition={{ top: -6, left: 14 }}
        countryCodeInput={{
          props: {
            style: {
              padding: "0.5rem 0.5rem 0.5rem 52px",
              width: "112px",
              backgroundColor: "#f9f9f9",
              cursor: "pointer",
              borderRadius: "8px 0 0 8px",
              marginBottom: 12,
              textWrap: "nowrap",
            },
          },
        }}
        localNumberInput={{
          props: {
            style: {
              borderLeft: "none",
              borderRadius: "0 8px 8px 0",
              width: "100%",
              padding: "0.5rem",
              marginBottom: 12,
            },
          },
        }}
      />
      timezone
      <TimeZonePicker timeZone={timeZone} setTimeZone={setTimeZone} />
    </SearchCard>
  );
}
